interface SampleCardProps {
  item: any;
  displayFields: { label: string; value: string }[];
  originalIndex: number;
  rowWidth: number;
  color: string;
  onItemClick?: (item: any) => void;
}

/**
 * SampleCard Component
 * Displays a single data item as a card in the data flow visualization
 */
export default function SampleCard({
  item,
  displayFields,
  originalIndex,
  rowWidth,
  color,
  onItemClick,
}: SampleCardProps) {
  return (
    <div
      className="data-flow-row"
      onClick={() => {
        if (onItemClick) {
          onItemClick(item);
        }
      }}
      style={{
        width: `${rowWidth}px`,
        background: color,
      }}
    >
      {/* Header with timestamp or index */}
      <div className="data-flow-row-header">
        {item.timestamp
          ? new Date(item.timestamp).toLocaleTimeString()
          : `#${originalIndex + 1}`}
      </div>

      {/* Data fields */}
      <div className="data-flow-row-fields">
        {displayFields.map((field, fieldIndex) => (
          <div key={fieldIndex} className="data-flow-field">
            <span className="data-flow-field-label">
              {field.label}:
            </span>
            <span className="data-flow-field-value">{field.value}</span>
          </div>
        ))}
      </div>

      {/* Footer indicator */}
      <div className="data-flow-row-footer">Click to view RAW data</div>
    </div>
  );
}
